import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const removeAttendeesSlice = getBulkActionSlice(
    'removeAttendeesResult',
);

export const selectRemoveAttendeesUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.removeAttendeesResult.uuid;
export const selectRemoveAttendeesShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.removeAttendeesResult.shown;
export const selectRemoveAttendeesTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.removeAttendeesResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = removeAttendeesSlice.actions;
